import { render, staticRenderFns } from "./RelatoriosIA.vue?vue&type=template&id=17ff8983"
import script from "./relatorios/RelatoriosIA.js?vue&type=script&lang=js&external"
export * from "./relatorios/RelatoriosIA.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports